/* eslint-disable @typescript-eslint/no-explicit-any */
var StringIsNumber = function StringIsNumber(value) {
  return isNaN(Number(value)) === false;
};

// Turn enum into array
function EnumsToArray(e) {
  return Object.keys(e).filter(StringIsNumber).map(function (key) {
    return e[key];
  });
}

export default EnumsToArray;
//# sourceMappingURL=enum-to-array.esm.js.map
